export enum FeatureFlag {
  /* Maintenance and Triggers */
  HealthCheckCron = 'health-check-cron',
  Maintenance = 'maintenance',
  Refresh = 'force-refresh',
  Logout = 'force-logout',

  /* Feature Flags */
  AdaptiveCharts = 'adaptive-charts',
  AIPageBuilder = 'ai-page-builder',
  GlobalAIAssistant = 'global-ai-assistant',
  AiSearchWiderDashboard = 'ai-search-wider-dashboard',
  CompanyDiscoveryValuationFilter = 'company-discovery-valuation-filter',
  CompositionV3 = 'composition-v3',
  CustomDashViewEditToggle = 'custom-dash-view-edit-toggle',
  DashboardNewLayout = 'dashboard-new-layout',
  DraggablePagesTabs = 'draggable-pages-tabs',
  CustomReports = 'custom-reports',
  CustomReportsSnowflake = 'custom-reports-snowflake',
  DataBuilderSftp = 'data-builder-sftp',
  ExperimentalReports = 'experimental-reports',
  DiscoveryStateGeography = 'discovery-state-geography',
  GeographyUserPreference = 'geography-user-preference',
  Impersonation = 'impersonation',
  IndividualPotential = 'individual-potential-page',
  PPTPreview = 'ppt-preview',
  PromoteMarketConditionsReportTemplate = 'promote-market-conditions-report-template',
  PromoteOrgHealthReportTemplate = 'promote-org-health-report-template',
  PromoteSentimentReportTemplate = 'promote-sentiment-report-template',
  ReferenceApi = 'reference-api',
  SelectionListIds = 'enable-selection-list-ids',
  SharedReports = 'shared-reports',
  SharedPlots = 'shared-plots',
  TalentDiscoveryStateGeography = 'talent-discovery-state-geography',
}
